module.exports = __webpack_public_path__ + "img/Tokelau.7652dc67.svg";